/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="74.1"
        viewBox="0 0 95.58 74.1"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M62.73 0a1.25 1.25 0 0 1 1.13.72v.13l4.83 14.18h22.3a4.52 4.52 0 0 1 4.54 4.27v.2h-2.5a2 2 0 0 0-1.89-2H67.85a1.26 1.26 0 0 1-1.14-.72v-.12L61.83 2.5H33.75l-4.83 14.19a1.26 1.26 0 0 1-1.05.84H4.55a2 2 0 0 0-2 1.83v.14H0a4.51 4.51 0 0 1 4.33-4.47h22.51L31.67.85a1.24 1.24 0 0 1 1-.84h30ZM2.5 69.63a2 2 0 0 0 1.89 2h86.65a2 2 0 0 0 2-1.82v-.15h2.5a4.51 4.51 0 0 1-4.33 4.47H4.55A4.53 4.53 0 0 1 0 69.87v-.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M32.86 0h-.14a1.24 1.24 0 0 0-1 .84l-4.88 14.19h-5.17V12.2a3.22 3.22 0 0 0-3.17-3.21H9.82a3.21 3.21 0 0 0-3 3.21v2.83H4.55A4.52 4.52 0 0 0 0 19.5v50.12a4.52 4.52 0 0 0 4.55 4.47h86.49a4.51 4.51 0 0 0 4.54-4.47V19.3a4.51 4.51 0 0 0-4.54-4.26h-22.3L63.91.85A1.25 1.25 0 0 0 62.73 0Zm.89 2.5h28.08l4.83 14.19a1.27 1.27 0 0 0 1.19.85h23.19a2 2 0 0 1 2 2v50.12a2 2 0 0 1-2 2H4.55a2 2 0 0 1-2-2V19.5a2 2 0 0 1 2-2h3.49a1.25 1.25 0 0 0 1.25-1.25V12.2a.71.71 0 0 1 .72-.71h8.49a.72.72 0 0 1 .72.71v4.09a1.25 1.25 0 0 0 1.2 1.21h7.45a1.26 1.26 0 0 0 1.05-.84Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M57.14 6.29a1.24 1.24 0 0 1 1.24 1.12v3.55a3.22 3.22 0 0 1-3 3.22H40.41a3.21 3.21 0 0 1-3.21-3V7.5a1.252 1.252 0 0 1 2.5-.13v3.55a.73.73 0 0 0 .63.72h14.84a.71.71 0 0 0 .71-.62V7.5a1.25 1.25 0 0 1 1.26-1.21ZM47.79 20.5A23.12 23.12 0 1 0 70.9 43.64 23.14 23.14 0 0 0 47.79 20.5Zm0 2.5a20.62 20.62 0 1 1-20.61 20.64 20.63 20.63 0 0 1 20.61-20.62Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M47.44 23.03a20.61 20.61 0 1 0 .7 0h-.7Zm.73-2.5a23.11 23.11 0 1 1-.76 0h.76Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M47.79 27.7a15.94 15.94 0 0 1 0 31.87 1.25 1.25 0 0 1 0-2.5 13.44 13.44 0 1 0-13.43-13.44 1.25 1.25 0 0 1-2.5 0A16 16 0 0 1 47.79 27.7Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'CameraIcon';

export default Icon;
